module.exports = __webpack_public_path__ + "img/frame_one.fd7d51fe.png";